<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl" persistent)
  v-card
    v-card-title.pa-0
    div.px-6.pt-2.pb-2
      .text-lg.font-medium.mt-6 {{ $t('delete_confirmation', { text: 'payment' }) }}
      .text-md.mt-4
        span.font-semibold {{ amount | displayPrice }}&nbsp;
        span will be added back to your outstanding balance.
      .text-md.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider.mt-6
    v-card-actions.px-6.py-3
      v-btn.button-md.neutral700--text.px-0.underline(text :disabled="isLoading" @click="showDialog = false") {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(:loading="isLoading" color="danger500" depressed dark @click="handleConfirm") {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    open: {
      type: Boolean,
    },
    uid: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
  },
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    handleConfirm () {
      this.isLoading = true
      const endpoint = `/purchases/${this.company.slug}/payments/${this.uid}`
      this.$axios.delete(endpoint)
        .then(() => {
          this.updateActivityLog(endpoint, null, null, 'DELETE', this.uid)
          this.showMessage(['success', this.$t('success_message.delete_successful')])
          this.$emit('deleted')
          this.showDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateActivityLog (endpoint, payload, response, method, id) {
      let data = {
        company: this.company.id,
        object_id: id,
        object_ref: null,
        activity: 'Delete payment record',
        raw_data: { endpoint, payload, response, method }
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
  }
}
</script>